// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import AmountOfUseHistoryPanelItem from './amount-of-use-history-panel-item';
import AmountOfUseHistoryPanelListHeader from './amount-of-use-history-panel-list-header';
import AmountOfUsePanelRequestListHeader from './amount-of-use-panel-request-list-header';
import AmountOfUseRequestPanelItem from './amount-of-use-request-panel-item';
import AmountOfUseRequestStatusPanel from './amount-of-use-request-status-panel';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';

export const buildUseAmount = useAmount => `${useAmount.amount} ${useAmount.unit.value}`;

const AmountOfUseHistoryPanelBody = props => {

    const hasNonApprovedStatus = props.amountOfUseHistory.some(
        measurementReading => measurementReading.status && measurementReading.status.toLowerCase() !== 'approved'
    );

    return (

        <section className='amount-of-use-history-panel-body'>
            <AmountOfUseHistoryPanelListHeader/>
            <section className='amount-of-use-history-panel-list'>
                {props.amountOfUseHistory.filter(measurementReading => measurementReading.status !== null && measurementReading.status.toLowerCase() === 'approved')
                .map((measurementReading, index) =>
                    <AmountOfUseHistoryPanelItem
                        amountRecorded={measurementReading.useAmount.amount}
                        date={measurementReading.date}
                        description={measurementReading.description}
                        key={index}
                        unit={measurementReading.useAmount.unit.value}
                    />
            )}
            </section>
            {hasNonApprovedStatus && <div>
                <AmountOfUseRequestStatusPanel/>
                <AmountOfUsePanelRequestListHeader/>
            </div>}
            <section className='amount-of-use-history-panel-list'>
                {props.amountOfUseHistory.filter(measurementReading => measurementReading.status !== null && measurementReading.status.toLowerCase() !== 'approved')
            .map((measurementReading, index) =>
                <AmountOfUseRequestPanelItem
                    amountOfUse={buildUseAmount(measurementReading.useAmount)}
                    commentsToDealer={measurementReading.commentsToDealer}
                    date={measurementReading.date}
                    id={measurementReading.id}
                    key={index}
                    status={measurementReading.status}
                />
            )}
            </section>

        </section>

    );

};

AmountOfUseHistoryPanelBody.displayName = 'AmountOfUseHistoryPanelBody';
AmountOfUseHistoryPanelBody.propTypes = {
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired
};

export default AmountOfUseHistoryPanelBody;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-history-panel-body.js